// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__Ul-xJ","footer":"Form_footer__1NN0C"};